import { Pipe, PipeTransform } from '@angular/core';
import { BaseAgency, UserInfoStateStructure, USER_ROLE } from '@ptl/account-management';

@Pipe({
    name: 'NoSuperAgencyForInternalUser',
    standalone: false
})
export class NoSuperAgencyForInternalUser implements PipeTransform {

  transform(agencies: BaseAgency[], userType: USER_ROLE): BaseAgency[] {

    if (!agencies) { return []; }
    
    const isInternalRole = userType.toLowerCase() === USER_ROLE.INTERNAL.toLowerCase();
    if (isInternalRole) {
      return agencies.filter( a => !a.entitlements )
    } else {
      return agencies;
    }
  }

}
